import Flex from 'components/common/Flex';
import { LineChart } from 'echarts/charts';
import * as echarts from 'echarts/core';
import { rgbaColor } from 'helpers/utils';
import React from 'react';
import { Badge, Card } from 'react-bootstrap';
import PropTypes from 'prop-types';

import BasicECharts from 'components/common/BasicEChart';
import {
  GridComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LineChart,
  CanvasRenderer
]);

export const CriticalMissingScanned = ({
  title,
  total,
  labels,
  data,
  color,
  gap
}) => {
  const getOptions = data => ({
    tooltip: {
      trigger: 'axis',
      formatter: '<i>{b0}</i> : {c0} frame(s)'
    },
    xAxis: {
      data: labels
    },
    series: [
      {
        type: 'line',
        data: data,
        smooth: true,
        lineStyle: {
          width: 3
        },

        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: rgbaColor(color, 0.25)
              },
              {
                offset: 1,
                color: rgbaColor(color, 0)
              }
            ]
          }
        }
      }
    ],
    grid: {
      bottom: '0%',
      top: '10%',
      right: '0px',
      left: '10px'
    }
  });
  return (
    <Card style={{ width: '350px', height: '155px' }}>
      <Card.Header className="pb-0">
        <h6 className="mb-0 mt-2">{title}</h6>
      </Card.Header>
      <Card.Body
        as={Flex}
        alignItems="end"
        justifyContent="between"
        className=""
      >
        <div className="pb-4">
          <h2 className="fw-normal text-700 mb-1 lh-1">{total}</h2>
          <Badge
            pill
            bg="200"
            className={gap > 0 ? 'text-danger fs-11' : 'text-primary fs-11'}
          >
            <FontAwesomeIcon
              icon={gap > 0 ? 'caret-up' : 'caret-down'}
              className="me-1"
            />
            {gap.toFixed(2)}%
          </Badge>
        </div>
        <div className="ps-0 mt-n4">
          <BasicECharts
            echarts={echarts}
            options={getOptions(data)}
            style={{ width: '15rem', height: 100 }}
          />
        </div>
      </Card.Body>
    </Card>
  );
};

CriticalMissingScanned.propTypes = {
  title: PropTypes.string,
  total: PropTypes.number,
  labels: PropTypes.array,
  data: PropTypes.array,
  color: PropTypes.string,
  gap: PropTypes.number
};
